module.exports = __webpack_public_path__ + "static/media/sub2.b4a9e10f.png";